import { ArrowRight } from "lucide-react";
import { Sparks } from "@/components/common/Sparks";
import { Container } from "@/components/ui/Container";
import { Button } from "@/components/ui/Button";
import { Reveal } from "@/components/common/Reveal";
import { useScrollTo } from "@/hooks/useScrollTo";

export const CtaBanner = () => {
  const scrollTo = useScrollTo();
  return (
    <section data-testid="cta-banner" className="relative py-24 overflow-hidden bg-charcoal">
      <div className="absolute inset-0 blueprint-bg blueprint-anim opacity-40" />
      <Sparks count={14} />
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 50%, rgba(107,255,61,0.10), transparent 60%)" }} />
      <Container className="relative max-w-3xl text-center">
        <Reveal>
          <h2 className="font-display text-5xl md:text-7xl text-white leading-none">
            Ready To Get Your Project <span className="text-weld-glow text-glow">Welded?</span>
          </h2>
          <p className="text-white/70 mt-5 text-lg">Send us your project details and photos to get started.</p>
          <Button data-testid="cta-banner-quote" size="lg" className="mt-8" onClick={() => scrollTo("contact")}>
            Request a Quote <ArrowRight size={18} />
          </Button>
        </Reveal>
      </Container>
    </section>
  );
};
